import { styled } from "@mui/material";
import Button from "@mui/material/Button";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import LinkButton from "../../../components/link-button/link-button";
import { IRootState } from "../../../redux/root.reducer";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

const History = ({ className }: IWithClassName) => {
    const { data: history, isLoading } = useSelector(
        (state: IRootState) => state.home.history,
    );
    return (
        <div className={className}>
            <h2 className="history-list-title">HISTORY</h2>
            <div className="history-list">
                {isLoading ? (
                    <Skeleton count={5} className="skeleton" />
                ) : (
                    <>
                        {history?.length ? (
                            history.map((item) => (
                                <Button
                                    LinkComponent={LinkButton}
                                    key={item.listId}
                                    className="history-list-btn"
                                    variant="text"
                                    href={`/list/${item.listId}`}
                                >
                                    {item.name}
                                </Button>
                            ))
                        ) : (
                            <div className="no-history">No history yet</div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default styled(History)(({ theme }: IWithThemeProps) => ({
    flexGrow: 1,
    borderRadius: theme?.spacing(2.5),
    ".history-list-title": {
        fontWeight: 600,
        fontSize: 20,
        marginTop: theme?.spacing(6),
        marginBottom: theme?.spacing(2.5),
        color: theme?.palette.history.titleColor,
    },
    ".history-list": {
        backgroundColor: theme?.palette.history.bgColor,
        padding: theme?.spacing(2, 5),
        borderRadius: theme?.spacing(2.5),
        display: "flex",
        flexGrow: 0,
        flexDirection: "column",
    },
    ".history-list-btn": {
        color: theme?.palette.history.textColor,
        fontSize: 28,
        fontWeight: 700,
        lineHeight: 1,
        marginBottom: theme?.spacing(1),
        marginTop: 0,
        alignSelf: "start",
    },
    ".skeleton": {
        margin: theme?.spacing(1),
    },
    ".no-history": {
        color: theme?.palette.history.textColor,
        fontSize: 22,
    },
}));
